class PreorderDisclaimer extends HTMLElement {
    connectedCallback() {
        this.deployElement = this.deployElement.bind(this);
        document.addEventListener('cart:update', this.deployElement);
        this.deployElement();
    }

    disconnectedCallback() {
        document.removeEventListener('cart:update', this.deployElement);
    }

    async deployElement() {
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            const { items = [] } = await response.json();

            const hasFullPayment = items.some(
                item => item?.selling_plan_allocation?.selling_plan?.name === 'Preorder'
            );

            this.classList.toggle('hide', !hasFullPayment);
        } catch (error) {
            console.error('Error loading cart:', error);
            this.classList.add('hide');
        }
    }
}

customElements.define('preorder-disclaimer', PreorderDisclaimer);